export default __webpack_public_path__ + "static/media/4.9d3bea76.jpg";